import React from 'react';
import { Link } from 'react-router-dom';
import { mockRockets } from '../services/dataService';
import { getRocketImage } from '../utils/imageUtils';

/**
 * Rocket List Page Component
 */
const RocketList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        🚀 Rockets
      </h1>
      <div className="grid">
        {mockRockets.map(rocket => (
          <div key={rocket.id} className="card">
            <img 
              src={getRocketImage(rocket.id, rocket.name)} 
              alt={rocket.name}
              style={{ 
                width: '100%', 
                height: '250px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {rocket.name}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Type:</strong> {rocket.type}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Manufacturer:</strong> {rocket.manufacturer}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Status:</strong> {rocket.status}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Height:</strong> {rocket.height}m | <strong>Mass:</strong> {rocket.mass.toLocaleString()}kg
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Payload Capacity:</strong> {rocket.payloadCapacity.toLocaleString()}kg
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Fuel:</strong> {rocket.fuelType}
            </p>
            <Link to={`/rockets/${rocket.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RocketList;
